import React from "react";
import { themes } from "services/constants";
import { Avatar, Box, Typography, Tooltip } from "@mui/material";
import { tooltipStyleProps } from "services/constants/Styles";

export const UserDetailsRow = ({ userDetails, isEditRecord = true }) => {
  return (
    <React.Fragment>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            p: 1,
            border: `2px solid ${themes?.miliedLightGray}`,
            borderRadius: 2,
            backgroundColor: "#F5F5FD",
          }}
        >
          {/* Avatar */}
          <Avatar
            src={userDetails?.image_url}
            alt={userDetails?.user_name}
            sx={{
              width: 64,
              height: 64,
            }}
          />

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "100px 1fr 100px 1fr",
              rowGap: 1,
              columnGap: 2,
              width: "100%",
            }}
          >
            <Typography fontWeight={600}>Emp Name</Typography>
            <Typography>{userDetails?.user_name ?? "-"}</Typography>

            <Typography fontWeight={600}>Emp ID</Typography>
            <Typography>{userDetails?.employee_id ?? "-"}</Typography>

            <Typography fontWeight={600}>Department</Typography>
            <Typography>{userDetails?.department_name ?? "-"}</Typography>

            <Typography fontWeight={600}>Designation</Typography>
            <Typography>{userDetails?.designation ?? "-"}</Typography>
          </Box>
        </Box>
      </Box>

      {/* Shift Card */}
      {!isEditRecord && (
        <Box sx={{ mb: 0.5 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "90px 1fr 21px 80px 1fr",
              rowGap: 1.2,
              columnGap: 4,
              mt: 1.5,
              p: 1.5,
              border: `2px solid ${themes?.miliedLightGray}`,
              borderRadius: 2,
              backgroundColor: "#fff",
            }}
          >
            <Typography fontWeight={600}>Shift Name</Typography>
            <Tooltip
              arrow
              slotProps={tooltipStyleProps}
              title={
                <>
                  {userDetails?.shift_name ?? "-"} ({userDetails?.shift_start} -{" "}
                  {userDetails?.shift_end})
                </>
              }
            >
              <Typography sx={{ cursor: "pointer" }}>
                {userDetails?.shift_name ?? "-"}
              </Typography>
            </Tooltip>

            <Box />

            <Typography fontWeight={600}>Check In</Typography>
            <Typography>{userDetails?.check_in_time ?? "00:00"}</Typography>

            <Typography fontWeight={600}>AR Date</Typography>
            <Typography>{userDetails?.date ?? "-"}</Typography>
            <Box />

            <Typography fontWeight={600}>Check Out</Typography>
            <Typography>{userDetails?.check_out_time ?? "00:00"}</Typography>
          </Box>
        </Box>
      )}
    </React.Fragment>
  );
};
